/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Meal from './meal';
import MealDetail from './meal-detail';
import MealUpdate from './meal-update';
import MealDeleteDialog from './meal-delete-dialog';

const MealRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Meal />} />
    <Route path="new" element={<MealUpdate />} />
    <Route path=":id">
      <Route index element={<MealDetail />} />
      <Route path="edit" element={<MealUpdate />} />
      <Route path="delete" element={<MealDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default MealRoutes;
